export default function initialsFromCamelCase(name) {
  const firstChar = name.charAt(0).toUpperCase();
  const capitals = [...name].filter((c) => /[A-Z]/.test(c));
  return [
    firstChar,
    ...capitals,
  ].join('');
}
